import type { SVGProps } from "react";

export default function DividerIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M4.90415 1.84351H15.0935C16.512 1.84351 17.2212 1.84351 17.4539 2.29552C17.6864 2.74754 17.2742 3.32466 16.4498 4.4789L15.5085 5.79661C15.1419 6.30981 14.9587 6.56642 14.6894 6.70496C14.4203 6.84351 14.1049 6.84351 13.4742 6.84351H6.52348C5.89279 6.84351 5.57744 6.84351 5.30823 6.70496C5.03902 6.56642 4.85573 6.30981 4.48915 5.79661L3.54794 4.47891C2.72347 3.32466 2.31125 2.74754 2.54386 2.29552C2.77647 1.84351 3.4857 1.84351 4.90415 1.84351Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M4.90415 18.5098H15.0935C16.512 18.5098 17.2212 18.5098 17.4539 18.0578C17.6864 17.6058 17.2742 17.0286 16.4498 15.8743L15.5085 14.5567C15.1419 14.0434 14.9587 13.7868 14.6894 13.6483C14.4203 13.5098 14.1049 13.5098 13.4742 13.5098H6.52348C5.89279 13.5098 5.57745 13.5098 5.30823 13.6483C5.03902 13.7868 4.85573 14.0434 4.48915 14.5567L3.54794 15.8743C2.72347 17.0286 2.31125 17.6058 2.54386 18.0578C2.77647 18.5098 3.4857 18.5098 4.90415 18.5098Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M8.33252 10.1768H11.6659"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M14.9985 10.1768H18.3319"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M1.66553 10.1768H4.99886"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
    </svg>
  );
}
